import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'

const StyledGroup = styled(Group)`
  padding: ${rem(16)} 0;
`

function HotelSearchSplitViewNoResults() {
  const intl = useIntl()

  const headingText = intl.formatMessage({
    id: 'YX-KMe_7fiLr4RHbSxFe',
    defaultMessage: 'Sorry, we couldn’t find any offers that match your search criteria.',
  })

  const suggestionText = intl.formatMessage({
    id: 'cm5ADo0qz8eWpUVyRVdF',
    defaultMessage: 'Try removing some filters or searching a different location to see more options.',
  })

  return (
    <StyledGroup direction="vertical" horizontalAlign="center" verticalAlign="center" gap={8}>
      <Heading variant="heading3" align="center">
        {headingText}
      </Heading>
      <BodyText variant="medium">
        {suggestionText}
      </BodyText>
    </StyledGroup>
  )
}

export default HotelSearchSplitViewNoResults
